<style scoped>

  @media only screen and (min-width: 991px) {
    .inline.fields {
      margin-top: -15px !important;
    }
  }

</style>

<template>

  <div>

    <div class="ui large breadcrumb">
      <a class="clickable" @click="goBack()">
        <i class="reply icon m-r-5"></i> Fornecedores
      </a>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>{{ isCreating ? creatingTitle : updatingTitle }}</strong>
      </div>
    </div>

    <bookmark-button v-if="isCreating" :label="creatingTitle" />

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-show="!loading" class="animated fadeIn">      

      <div class="ui segment form-segment">
        <h4 class="ui dividing header">Dados Cadastrais</h4>
        <div class="ui form">
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Pessoa</label> 
            </div> 
          </div>
          <div class="inline fields">
            <div class="field">
              <div class="ui radio checkbox supplier-form-checkbox">
                <input type="radio" class="hidden" value="J" v-model="supplier.person" @change="supplier.cgc = ''">
                <label><i class="building outline red icon"></i>Jurídica</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox supplier-form-checkbox m-l-10">
                <input type="radio" class="hidden" value="F" v-model="supplier.person" @change="supplier.cgc = ''">
                <label><i class="user outline blue icon"></i>Física</label>
              </div>
            </div>
          </div>
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">Usuário</label>
              <user-picker ref="userPicker" attributes="*" :uppercase="true" @onPick="onPickUser" @onClear="supplier.userId = null" />
            </div>    
            <div class="five wide field">
              <label class="form-label">{{ supplier.person == 'J' ? 'Razão Social' : 'Nome Completo' }} <span class="red text">*</span></label>
              <input class="uppercase" v-model="supplier.name" @blur="supplier.name = $toUpperCase($event)">
            </div>         
            <div class="four wide field">
              <label class="form-label">{{ supplier.person == 'J' ? 'Nome Fantasia' : 'Nome Reduzido' }} <span class="red text">*</span></label>
              <input class="uppercase" v-model="supplier.shortName" @blur="supplier.shortName = $toUpperCase($event)">
            </div>         
            <div class="three wide field animated fadeIn">
              <label class="form-label">{{ supplier.person == 'J' ? 'CNPJ' : 'CPF' }}</label>
              <the-mask type="tel" :mask="['##.###.###/####-##', '###.###.###-##']" v-model="supplier.cgc" />
            </div>                
          </div>          
          <div class="fields">
            <div class="four wide field animated fadeIn">
              <label class="form-label">CEP</label>
              <the-mask type="tel" :mask="'#####-###'" v-model="supplier.zipCode" @blur.native="loadAddressByZipCode()" />
            </div>
            <div class="seven wide field">
              <label class="form-label">Logradouro</label>
              <input class="uppercase" placeholder="Rua, Avenida, Praça, etc." v-model="supplier.address" @blur="supplier.address = $toUpperCase($event)">
            </div>
            <div class="two wide field">
              <label class="form-label">Número</label>
              <input class="uppercase" v-model="supplier.number" @blur="supplier.number = $toUpperCase($event)">
            </div>
            <div class="three wide field">
              <label class="form-label">Complemento</label>
              <input class="uppercase" v-model="supplier.complement" @blur="supplier.complement = $toUpperCase($event)">
            </div>            
          </div>
          <div class="fields">            
            <div class="four wide field">
              <label class="form-label">Bairro</label>
              <input class="uppercase" v-model="supplier.district" @blur="supplier.district = $toUpperCase($event)">
            </div>
            <div class="seven wide field">
              <label class="form-label">Município</label>
              <input class="uppercase" v-model="supplier.city" @blur="supplier.city = $toUpperCase($event)">
            </div>
            <div class="five wide field">
              <label class="form-label">Estado</label>
              <select-state ref="selectState" @onChange="onChangeState" />
            </div>                        
          </div>
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">Telefone</label>
              <input type="tel" v-model="supplier.phone">
            </div>               
            <div class="four wide field">
              <label class="form-label">Celular</label>
              <input type="tel" v-model="supplier.mobile">
            </div> 
          </div>          
        </div>
      </div> 

      <div class="m-t-20">
        <button class="ui basic button" @click="goBack()">
          <i class="reply icon"></i> Cancelar
        </button>
        <button v-if="isUpdating" class="ui basic red button m-l-10" 
          :class="{ loading: checkingRemoval || removing }" @click="onRemove()">
          <i class="trash icon"></i> Excluir
        </button> 
        <button class="ui right floated blue button" :class="{ loading: saving }" @click="onConfirm()">
          <i class="check icon"></i> {{ isCreating ? 'Confirmar' : 'Atualizar' }}
        </button>         
      </div>

      <can-not-remove-modal ref="canNotRemoveModal" />

      <yes-no-modal ref="confirmRemovalModal" danger="true"
        :message="`Confirma exclusão do fornecedor ${supplier.name} ?`"  @onYes="onConfirmRemoval()" />

    </div>
  
  </div>  
  
</template>

<script>
  
  import { TheMask } from "vue-the-mask"
  import { formPage, onlyFinancial } from "@/mixins"
  import { UserPicker, SelectState } from "@/components"  
  import SupplierService from "@/services/supplier-service"  
  import ZipCodeService from "@/services/zip-code-service"

  export default {
    
    name: "SupplierForm",

    mixins: [formPage, onlyFinancial],

    data() {
      return {
        creatingTitle: "Novo Fornecedor",
        updatingTitle: "Alterar Fornecedor",
        indexRoute: "/financial/suppliers",
        service: new SupplierService(),
        supplier: { person: "J" },
      }
    },    

    components: {
      UserPicker,
      SelectState,
      TheMask,
    },

    created() {
      
      this.initFormPage()

      if (this.isUpdating)
        this.loadSupplier()      
    },    

    mounted() {      
      $(".supplier-form-checkbox").checkbox()
    },

    methods: {

      async loadSupplier() {

        this.loading = true

        try {

          this.supplier = await this.service.findById(this.$route.params.id)

          if (this.supplier.user)
            this.$refs.userPicker.setSelected(this.supplier.user)

          this.$refs.selectState.setSelected(this.supplier.state)  

        } catch (error) {          

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },

      onPickUser(user) {
        
        const { name, lastName, cgc, email, mobile, phone, zipCode, address, number, complement, district, city, state } = user

        this.supplier.name = name.trim().toUpperCase() + " " + lastName.trim().toUpperCase()
        this.supplier.shortName = this.supplier.name
        this.supplier.cgc = cgc
        this.supplier.person = cgc && cgc.trim().length > 11 ? "J" : "F"
        this.supplier.email = email
        this.supplier.userId = user.id
        this.supplier.mobile = mobile
        this.supplier.phone = phone
        this.supplier.zipCode = zipCode
        this.supplier.address = address
        this.supplier.number = number
        this.supplier.complement = complement
        this.supplier.district = district
        this.supplier.city = city
        
        this.$refs.selectState.setSelected(state)

        this.supplier = this.$cloneObject(this.supplier)
      },

      async loadAddressByZipCode() {

        if (!this.supplier.zipCode || this.supplier.zipCode.trim().length < 8)
          return
        
        try {

          const data = await ZipCodeService.fetch(this.supplier.zipCode)

          if (!data || data.erro)
            return

          this.supplier.address = data.logradouro.toUpperCase()          
          this.supplier.district = data.bairro.toUpperCase()
          this.supplier.city = data.localidade.toUpperCase()

          this.$refs.selectState.setSelected(data.uf)          
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },

      onChangeState(state) {        
        this.supplier.state = state
        this.supplier = this.$cloneObject(this.supplier)
      },

      async onConfirm() {

        if (!this.validData())
          return

        this.saving = true

        try {

          if (this.isCreating) {
            await this.service.create(this.supplier)
          } else {
            await this.service.update(this.supplier)
          }

          this.$reloadDataTables()

          this.$msg.success(this.isCreating ? "Fornecedor criado com sucesso" : "Fornecedor atualizado com sucesso")

          this.goBack()

        } catch (error) {

          this.saving = false

          this.$errorHandler(error)
        }
      },

      validData() {

        let isOk = true
        let message = ""
        const { person, name, shortName } = this.supplier

        if (!name) {
          message = person == "J" ? "Informe a razão social do fornecedor" : "Informe o nome completo do fornecedor"
        } else if (!shortName) {
          message = person == "J" ? "Informe o nome fantasia do fornecedor" : "Informe o nome reduzido do fornecedor"  
        }

        if (message) {
          isOk = false
          this.$msg.info(message)
        }

        return isOk
      },

      async onRemove() {

        this.checkingRemoval = true

        try {

          const data = await this.service.canRemove(this.supplier)

          if (data.canRemove)  {
            this.$refs.confirmRemovalModal.show()              
          } else {
            this.$refs.canNotRemoveModal.show(data.entities)            
          }

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.checkingRemoval = false
        }        
      },

      async onConfirmRemoval() {
        
        this.removing = true

        try {

          await this.service.remove(this.supplier)

          this.$reloadDataTables()

          this.$msg.success("Fornecedor excluído com sucesso")

          this.goBack()

        } catch (error) {

          this.removing = false

          this.$errorHandler(error)
        }
      }
    },
  }

</script>

